var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { KnownContext, } from '@spotify-internal/remote-config-core';
import { createSptCookieConsentClientNonAuth } from '@spotify-internal/event-definitions/es5/events/createSptCookieConsentClientNonAuth';
let trackjs;
try {
    trackjs = require('@spotify-internal/track-js');
}
catch (e) {
}
export const consentExposureMiddleware = (next) => {
    return ({ eventSender, onDestroy }) => {
        let latestSptCookie;
        const sendConsentEvent = (consentInfo) => {
            if (!latestSptCookie || !consentInfo) {
                return;
            }
            const eventData = {
                spt_cookie: latestSptCookie,
                consent_groups: Object.entries(consentInfo.groups)
                    .map(([key, value]) => `${key}:${value ? '1' : '0'}`)
                    .join(','),
                datetime: consentInfo.date.getTime(),
            };
            eventSender.send(createSptCookieConsentClientNonAuth(eventData));
        };
        trackjs.addConsentListener(sendConsentEvent, true);
        onDestroy(() => {
            trackjs.removeConsentListener(sendConsentEvent);
        });
        return (context) => __awaiter(void 0, void 0, void 0, function* () {
            const configurationBuilder = yield next(context);
            const currentSptCookie = KnownContext.extractIdentifiersMap(context)['/client/sp-t-cookie'];
            if (!!currentSptCookie && latestSptCookie !== currentSptCookie) {
                latestSptCookie = currentSptCookie;
                const consentInfo = trackjs.getConsentInfo();
                if (consentInfo) {
                    sendConsentEvent(consentInfo);
                }
            }
            return configurationBuilder;
        });
    };
};
//# sourceMappingURL=consent-exposure.js.map